var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDownload2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-download",
    transform: "translate(-1040 -772)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(1040 772)",
    fill: "#dadce0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Solid",
    transform: "translate(1022.083 754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2406",
    "data-name": "Path 2406",
    d: "M143.448,31.243a.482.482,0,0,0,.681,0l1.816-1.816a.482.482,0,1,0-.681-.681l-.994.994V24.482a.482.482,0,0,0-.963,0V29.74l-.994-.994a.482.482,0,1,0-.681.681Z",
    transform: "translate(-115.133)",
    fill: "#36393d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2407",
    "data-name": "Path 2407",
    d: "M32.828,232a.482.482,0,0,0-.482.482v3.692H24.963v-3.692a.482.482,0,0,0-.963,0v3.852a.8.8,0,0,0,.8.8h7.7a.8.8,0,0,0,.8-.8v-3.852A.482.482,0,0,0,32.828,232Z",
    transform: "translate(0 -203.827)",
    fill: "#36393d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownload2);
export default __webpack_public_path__ + "static/media/ic-download2.e2ec229f.svg";
export { ForwardRef as ReactComponent };